import { Alert, CircularProgress, Stack } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

import ReportingHubForm from '../components/ReportingHub/ReportingHubForm';
import useReportTemplate from '../hooks/useReportTemplate';
import mapReportTemplateToForm from '../util/mapReportTemplateToForm';
import { ReportTemplate } from '../validationSchemas/ReportTemplateSchema';

function ReportingHubEditPage() {
  const { reportTemplateId } = useParams();
  const { data, isLoading } = useReportTemplate(Number(reportTemplateId));

  if (isLoading) {
    return (
      <Stack p={2}>
        <CircularProgress />
      </Stack>
    );
  }

  if (!(data && data.template && data?.template.reportTemplate)) {
    return <Alert severity="error">Unable to load template</Alert>;
  }

  const form:ReportTemplate = mapReportTemplateToForm(data?.template.reportTemplate);
  return <ReportingHubForm reportTemplate={form} />;
}

export default ReportingHubEditPage;
